import { BundleStatusEnum } from '#types';
import { DocumentTypeEnum } from '../../../blocks/SuggestDocumentCreateModal';
import { BundleCookie } from './bundleCookieType';

// For use when deciding what kind of PUN text to show when sending a document
export const isCreatingNotSendingDocument = (
	bundle: BundleCookie | undefined,
	documentType: DocumentTypeEnum
) => {
	if ( !bundle ) {
		return false;
	}
	if ( documentType === DocumentTypeEnum.Proposal ) {
		// if we've created a proposal, a proposal is part of this bundle, and there's at least one other document that's not sent, then we're creating and not sending
		return (
			bundle?.proposalBundleStatus &&
			[ bundle?.invoiceBundleStatus, bundle?.contractBundleStatus ].includes(
				BundleStatusEnum.Awaiting
			)
		);
	} else if ( documentType === DocumentTypeEnum.Contract ) {
		// if we've created a contract, a contract is part of this bundle, and there's at least one other document that's not sent, then we're creating and not sending
		return (
			bundle?.contractBundleStatus &&
			[ bundle?.invoiceBundleStatus, bundle?.proposalBundleStatus ].includes(
				BundleStatusEnum.Awaiting
			)
		);
	} else if ( documentType === DocumentTypeEnum.Invoice ) {
		// if we've created an invoice, an invoice is part of this bundle, and there's at least one other document that's not sent, then we're creating and not sending
		return (
			bundle?.invoiceBundleStatus &&
			[ bundle?.proposalBundleStatus, bundle?.contractBundleStatus ].includes(
				BundleStatusEnum.Awaiting
			)
		);
	}
	return false;
};
